import get from 'lodash/get';
import { selectors } from '../../Stream';
import { getCurrentUserHasCore } from '../../publicSession/selectors';
import { backgroundsStreamId, reduxKey } from './constants';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { getIsCurrentUserAuthorOf } from '../../redux/deviations/selectors';
import { getCurrentModal } from '../../Modals/redux/selectors';
import { ModalType } from '../../Modals/redux/types';
function getDeviationBackgroundState(state) {
    return state[reduxKey] || {};
}
export function canSetCustomBackground(state, deviation) {
    if (!getIsCurrentUserAuthorOf(state, deviation)) {
        return false;
    }
    const deviationType = getDeviationType(deviation);
    return [
        DeviationTypes.IMAGE,
        DeviationTypes.FILM,
        DeviationTypes.PDF
    ].includes(deviationType);
}
// this selector will only search already fetched backgrounds
export function getBackgroundById(state, backgroundId) {
    if (typeof backgroundId === 'undefined') {
        return 'default';
    }
    if (backgroundId < 0) {
        return 'default';
    }
    const backgrounds = selectors.getItems(state, backgroundsStreamId) || [];
    return backgrounds.find((bg)=>bg.backgroundId === backgroundId) || 'default';
}
export function getBackground(state, deviation) {
    const backgroundState = getDeviationBackgroundState(state);
    if (backgroundState && backgroundState.backgroundPreview) {
        return getBackgroundById(state, backgroundState.backgroundPreview);
    }
    const backgroundIdFromState = get(backgroundState, `${deviation.deviationId}.backgroundId`);
    if (backgroundIdFromState !== undefined) {
        return getBackgroundById(state, backgroundIdFromState);
    }
    return deviation.background || 'default';
}
export function getCurrentBackgroundId(state, deviation) {
    const deviationState = getDeviationBackgroundState(state)[deviation.deviationId];
    if (deviationState && deviationState.backgroundId !== undefined) {
        return deviationState.backgroundId;
    }
    if (!deviation.background) {
        return;
    }
    return deviation.background.backgroundId;
}
export function canUserSetBackground(state, backgroundId) {
    const background = getBackgroundById(state, backgroundId);
    if (background === 'default') {
        return true;
    }
    if (!background) {
        return false;
    }
    if (getCurrentUserHasCore(state)) {
        return true;
    }
    return !background.isPremium;
}
export function getIsBackgroundsPopupOpen(state) {
    var _getCurrentModal;
    return ((_getCurrentModal = getCurrentModal(state)) === null || _getCurrentModal === void 0 ? void 0 : _getCurrentModal.type) === ModalType.DEVIATION_BACKGROUND_PICKER;
}

//# sourceMappingURL=selectors.js.map